import React from "react";
import "./HemisphericSum.scss";

import { useTranslation } from "../../../i18n/TranslationProvider";
import { translateOr } from "../../../i18n/translateData";

const colors = {
  motor: "#b3e5fc",
  sensory: "#ffccbc",
  emotional: "#dab7ec",
  behavioral: "#ffdadb",
  cognitive: "#ffdcaf",
  immune: "#fff3c4",
  metabolic: "#cef3c4",
};

const HemisphericSum = ({ hemisphereDeficitBreakdown = [] }) => {
  const { t } = useTranslation();

  const translateSubcategory = (subcategory) => {
    const key = subcategory.charAt(0).toUpperCase() + subcategory.slice(1);
    return translateOr(t, `dashboard.symptomCategory.${key}`, subcategory);
  };

  // compute grand totals (will be 0 if breakdown is empty)
  const totalLeft = hemisphereDeficitBreakdown.reduce(
    (sum, b) => sum + Number(b.left_count),
    0
  );
  const totalRight = hemisphereDeficitBreakdown.reduce(
    (sum, b) => sum + Number(b.right_count),
    0
  );

  return (
    <div className="hemispheric-sum-container">
      <p className="hemispheric-sum-header">{t("dashboard.hemisphericSum.header")}</p>

      <div className="hemispheric-breakdown">
        {/* header row */}
        <div className="breakdown-header-row">
          <span className="breakdown-header-label left">{t("dashboard.hemisphericSum.left")}</span>
          <span className="breakdown-header-label category">
            {t("dashboard.hemisphericSum.breakdownHeader")}
          </span>
          <span className="breakdown-header-label right">{t("dashboard.hemisphericSum.right")}</span>
        </div>

        <ul className="breakdown-list">
          {hemisphereDeficitBreakdown.map(
            ({ subcategory, left_count, right_count }) => (
              <li key={subcategory} className="breakdown-item">
                <span
                  className="count"
                  style={{ color: left_count > 0 ? "black" : undefined }}
                >
                  {left_count}
                </span>

                <span
                  className="subcategory"
                  style={{ backgroundColor: colors[subcategory] || "#eee" }}
                >
                  {translateSubcategory(subcategory)}
                </span>

                <span
                  className="count"
                  style={{ color: right_count > 0 ? "black" : undefined }}
                >
                  {right_count}
                </span>
              </li>
            )
          )}

          {/* total row */}
          <li className="breakdown-item breakdown-total">
            <span
              className="count"
              style={{ color: totalLeft > 0 ? "black" : undefined }}
            >
              {totalLeft}
            </span>

            <span className="subcategory total">{t("dashboard.hemisphericSum.totalLabel")}</span>

            <span
              className="count"
              style={{ color: totalRight > 0 ? "black" : undefined }}
            >
              {totalRight}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HemisphericSum;